let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCTzj")).then(() => parcelRequire('kfn9p'));